<template>
  <v-container>
    <v-layout>
      <v-layout row wrap :class="['videos-list']" align-space-between fill-height>
        <v-flex lg12 md12 sm12 xs12 :class="['pa-2']">
          <v-card :class="['full-height']">
            <v-card-text :class="['pa-0', 'elevation-8']">
              <video-wrapper :src="makePlayerUrl($route.params.slug)" :play-videos-on-facebook="$config.playVideosOnFacebook" />
<!--              <div :class="['video-wrapper']">-->
<!--                <iframe-->
<!--                  seamless-->
<!--                  scrolling="no"-->
<!--                  frameborder="0"-->
<!--                  allowfullscreen="true"-->
<!--                  name="facebook-embedded-player"-->
<!--                  allow="autoplay;clipboard-write;encrypted-media;picture-in-picture;web-share"-->
<!--                  :src="makePlayerUrl($route.params.slug)" />-->
<!--              </div>-->
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-layout>
    <news-ticker />
  </v-container>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'PageVideosVideo',
  mixins: [
    methods
  ]
}
</script>



// WEBPACK FOOTER //
// src/pages/videos-video.vue